/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.8.2.0 (NJsonSchema v10.2.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming



export class BaseApiLoginResponse {
    identifier : string;
    username : string;
    role : string;
    token : string;

    constructor() 
    {
    	            this.identifier = "" ;
                this.username = "" ;
                this.role = "" ;
                this.token = "" ;
        }
}

export class DeleteNodesVm {
    nodes : string[];

    constructor() 
    {
    	            this.nodes = [];
        }
}

export class ValueIdentifierOfString {
    identifier : string;
    value : string;

    constructor() 
    {
    	            this.identifier = "" ;
                this.value = "" ;
        }
}

export class EditNodeVm {
    identifier : string;
    parentIdentifier : string;
    name : string;
    isFolder : boolean;
    htmlContent : string;
    iconUrl : string;
    userIdentifier : string;
    markToRead : boolean;

    constructor() 
    {
    	            this.identifier = "" ;
                this.parentIdentifier = "" ;
                this.name = "" ;
                this.isFolder = false ;
                this.htmlContent = "" ;
                this.iconUrl = "" ;
                this.userIdentifier = "" ;
                this.markToRead = false ;
        }
}

export class BaseEntity {
    identifier : string;
    createdOn : string ;
    modifiedOn : string ;
    disabledOn : string ;
    disabled : boolean;

    constructor() 
    {
    	            this.identifier = "" ;
                this.createdOn = null;
                this.modifiedOn = null;
                this.disabledOn = null;
                this.disabled = false ;
        }
}

export class ArchivioNode extends BaseEntity {
    name : string;
    order : number;
    parentIdentifier : string;
    isFolder : boolean;
    htmlContent : string;
    userIdentifier : string;
    iconUrl : string;
    readBy : ValueIdentifierOfDateTime[];

    constructor() 
    {
    	        super();
		            this.name = "" ;
                this.order = null ;
                this.parentIdentifier = "" ;
                this.isFolder = false ;
                this.htmlContent = "" ;
                this.userIdentifier = "" ;
                this.iconUrl = "" ;
                this.readBy = [];
        }
}

export class ValueIdentifierOfDateTime {
    identifier : string;
    value : string ;

    constructor() 
    {
    	            this.identifier = "" ;
                this.value = null;
        }
}

export class ArchivioNodeVm {
    parentIdentifier : string;
    isRead : boolean;
    identifier : string;
    isFolder : boolean;
    name : string;
    iconUrl : string;
    order : number;

    constructor() 
    {
    	            this.parentIdentifier = "" ;
                this.isRead = false ;
                this.identifier = "" ;
                this.isFolder = false ;
                this.name = "" ;
                this.iconUrl = "" ;
                this.order = null ;
        }
}

export class AssetVmForChallengeList {
    identifier : string;
    nome : string;
    codiceBloomberg : string;
    isin : string;
    microClass : string;
    macroClass : string;
    tipoAsset : string;
    valuta : string;
    idExcel : number;

    constructor() 
    {
    	            this.identifier = "" ;
                this.nome = "" ;
                this.codiceBloomberg = "" ;
                this.isin = "" ;
                this.microClass = "" ;
                this.macroClass = "" ;
                this.tipoAsset = "" ;
                this.valuta = "" ;
                this.idExcel = null ;
        }
}

export class AssetVm {
    identifier : string;
    nome : string;
    codiceBloomberg : string;
    isin : string;
    microClass : string;
    macroClass : string;
    tipoAsset : string;
    valuta : string;
    giorniValutaAcquisto : number;
    giorniValutaVendita : number;
    nav : DateValue;

    constructor() 
    {
    	            this.identifier = "" ;
                this.nome = "" ;
                this.codiceBloomberg = "" ;
                this.isin = "" ;
                this.microClass = "" ;
                this.macroClass = "" ;
                this.tipoAsset = "" ;
                this.valuta = "" ;
                this.giorniValutaAcquisto = null ;
                this.giorniValutaVendita = null ;
                this.nav = new DateValue();
        }
}

export class DateValue {
    date : string ;
    value : number;

    constructor() 
    {
    	            this.date = null;
                this.value = null ;
        }
}

export class AssetForBuyListVm {
    identifier : string;
    nome : string;
    valuta : string;
    nav : number;
    tipoAsset : string;
    performanceYtd : number;
    performance1Year : number;
    performance3Year : number;
    volatilita750 : number;
    tipo : string;

    constructor() 
    {
    	            this.identifier = "" ;
                this.nome = "" ;
                this.valuta = "" ;
                this.nav = null ;
                this.tipoAsset = "" ;
                this.performanceYtd = null ;
                this.performance1Year = null ;
                this.performance3Year = null ;
                this.volatilita750 = null ;
                this.tipo = "" ;
        }
}

export class AssetFilterVm {
    portafoglioIdentifier : string;
    challengeIdentifier : string;
    assetType : string;
    macroClass : string;
    microClass : string;
    idExcel : string;
    fromDate : string ;
    untilDate : string ;
    resocontoType : string;

    constructor() 
    {
    	            this.portafoglioIdentifier = "" ;
                this.challengeIdentifier = "" ;
                this.assetType = "" ;
                this.macroClass = "" ;
                this.microClass = "" ;
                this.idExcel = "" ;
                this.fromDate = null;
                this.untilDate = null;
                this.resocontoType = "" ;
        }
}

export class AssetPerformanceByMonthVm {
    year : number;
    monthValues : number[];

    constructor() 
    {
    	            this.year = null ;
                this.monthValues = [];
        }
}

export class BenchmarkVm {
    identifier : string;
    nome : string;
    codiceBloomberg : string;
    datiPeriodo : DatiPeriodo[];
    performance : DateValue[];
    volatilita750 : DateValue[];
    drawdown : Drawdown;
    performanceTable : AssetPerformanceVm[];

    constructor() 
    {
    	            this.identifier = "" ;
                this.nome = "" ;
                this.codiceBloomberg = "" ;
                this.datiPeriodo = [];
                this.performance = [];
                this.volatilita750 = [];
                this.drawdown = new Drawdown();
                this.performanceTable = [];
        }
}

export class DatiPeriodo {
    fattoreR : number;
    numeroPeriodi : number;
    periodiPositivi : number;
    periodiNegativi : number;
    performanceMax : number;
    performanceMin : number;
    performanceMedia : number;
    nomePeriodo : string;
    giorniMercato : number;

    constructor() 
    {
    	            this.fattoreR = null ;
                this.numeroPeriodi = null ;
                this.periodiPositivi = null ;
                this.periodiNegativi = null ;
                this.performanceMax = null ;
                this.performanceMin = null ;
                this.performanceMedia = null ;
                this.nomePeriodo = "" ;
                this.giorniMercato = null ;
        }
}

export class Drawdown {
    prezzoMin : DateValue;
    prezzoMax : DateValue;
    drawDown : number;
    dataInizioDrawdown : string ;
    dataFineDrawdown : string ;
    durataDrawdown : number;

    constructor() 
    {
    	            this.prezzoMin = new DateValue();
                this.prezzoMax = new DateValue();
                this.drawDown = null ;
                this.dataInizioDrawdown = null;
                this.dataFineDrawdown = null;
                this.durataDrawdown = null ;
        }
}

export class AssetPerformanceVm {
    anno : number;
    firstQ : number;
    secondQ : number;
    thirdQ : number;
    fourthQ : number;
    yearly : number;

    constructor() 
    {
    	            this.anno = null ;
                this.firstQ = null ;
                this.secondQ = null ;
                this.thirdQ = null ;
                this.fourthQ = null ;
                this.yearly = null ;
        }
}

export class Asset extends BaseEntity {
    idExcel : number;
    nome : string;
    nomeLungo : string;
    codiceBloomberg : string;
    isin : string;
    microClass : string;
    macroClass : string;
    tipo : string;
    tipoAsset : string;
    valuta : string;
    giorniValutaAcquisto : number;
    giorniValutaVendita : number;
    commissioni : DateValue[];
    retrocessioni : DateValue[];
    navs : DateValue[];
    variazioniGiornaliere : DateValue[];
    volatilita20 : DateValue[];
    volatilita750 : DateValue[];
    performance : DateValue[];
    drawdown : Drawdown;
    datiPeriodo : DatiPeriodo[];
    sortTipo : number;
    sortMacro : number;
    sortMicro : number;

    constructor() 
    {
    	        super();
		            this.idExcel = null ;
                this.nome = "" ;
                this.nomeLungo = "" ;
                this.codiceBloomberg = "" ;
                this.isin = "" ;
                this.microClass = "" ;
                this.macroClass = "" ;
                this.tipo = "" ;
                this.tipoAsset = "" ;
                this.valuta = "" ;
                this.giorniValutaAcquisto = null ;
                this.giorniValutaVendita = null ;
                this.commissioni = [];
                this.retrocessioni = [];
                this.navs = [];
                this.variazioniGiornaliere = [];
                this.volatilita20 = [];
                this.volatilita750 = [];
                this.performance = [];
                this.drawdown = new Drawdown();
                this.datiPeriodo = [];
                this.sortTipo = null ;
                this.sortMacro = null ;
                this.sortMicro = null ;
        }
}

export class AssetInPortafoglioVm {
    assetIdentifier : string;
    nome : string;
    codiceBloomberg : string;
    inPortafoglioDal : string ;
    macroClass : string;
    microClass : string;
    tipo : string;

    constructor() 
    {
    	            this.assetIdentifier = "" ;
                this.nome = "" ;
                this.codiceBloomberg = "" ;
                this.inPortafoglioDal = null;
                this.macroClass = "" ;
                this.microClass = "" ;
                this.tipo = "" ;
        }
}

export class LoginResponse {
    userIdentifier : string;
    token : string;
    nomeUtente : string;
    userImgUrl : string;

    constructor() 
    {
    	            this.userIdentifier = "" ;
                this.token = "" ;
                this.nomeUtente = "" ;
                this.userImgUrl = "" ;
        }
}

export class LoginData {
    password : string;
    email : string;

    constructor() 
    {
    	            this.password = "" ;
                this.email = "" ;
        }
}

export class LoginDataWithVersion extends LoginData {
    appVersion : string;

    constructor() 
    {
    	        super();
		            this.appVersion = "" ;
        }
}

export class RegisterVm {
    nome : string;
    cognome : string;
    email : string;
    password : string;
    appVersion : string;

    constructor() 
    {
    	            this.nome = "" ;
                this.cognome = "" ;
                this.email = "" ;
                this.password = "" ;
                this.appVersion = "" ;
        }
}

export class ChangePasswordVm {
    email : string;
    code : string;
    newPassword : string;

    constructor() 
    {
    	            this.email = "" ;
                this.code = "" ;
                this.newPassword = "" ;
        }
}

export class Challenge extends BaseEntity {
    titolo : string;
    descrizione : string;
    dataInizio : string ;
    dataFine : string ;
    percentualeRischio : number;
    stelline : number;
    winnerIdentifier : string;
    winnerName : string;
    defaultIdExcels : DefaultIdExcelForChallenge[];
    allowedAssets : number[];
    password : string;

    constructor() 
    {
    	        super();
		            this.titolo = "" ;
                this.descrizione = "" ;
                this.dataInizio = null;
                this.dataFine = null;
                this.percentualeRischio = null ;
                this.stelline = null ;
                this.winnerIdentifier = "" ;
                this.winnerName = "" ;
                this.defaultIdExcels = [];
                this.allowedAssets = [];
                this.password = "" ;
        }
}

export class DefaultIdExcelForChallenge {
    idExcel : number;
    percentuale : number;

    constructor() 
    {
    	            this.idExcel = null ;
                this.percentuale = null ;
        }
}

export class ChallengeVm {
    identifier : string;
    titolo : string;
    descrizione : string;
    percentualeRischio : number;
    dataInizio : string ;
    dataFine : string ;
    stelline : number;
    winnerName : string;
    winnerIdentifier : string;

    constructor() 
    {
    	            this.identifier = "" ;
                this.titolo = "" ;
                this.descrizione = "" ;
                this.percentualeRischio = null ;
                this.dataInizio = null;
                this.dataFine = null;
                this.stelline = null ;
                this.winnerName = "" ;
                this.winnerIdentifier = "" ;
        }
}

export class PremiUserGroupedVm {
    periodo : string;
    challengeName : string;
    numeroPremi : number;

    constructor() 
    {
    	            this.periodo = "" ;
                this.challengeName = "" ;
                this.numeroPremi = null ;
        }
}

export class AssegnaPremiVm {
    sendPushNotification : boolean;
    pushTitle : string;
    pushText : string;
    nodeOrder : number;
    challengeIdentifier : string;
    challengeName : string;
    tipoPremio : string;
    punteggioOro : number;
    punteggioArgento : number;
    punteggioBronzo : number;
    dataInizio : string ;
    dataFine : string ;
    generaNodo : boolean;
    nodeTitle : string;
    templateIdentifier : string;
    nodePath : ValueIdentifierOfString[];

    constructor() 
    {
    	            this.sendPushNotification = false ;
                this.pushTitle = "" ;
                this.pushText = "" ;
                this.nodeOrder = null ;
                this.challengeIdentifier = "" ;
                this.challengeName = "" ;
                this.tipoPremio = "" ;
                this.punteggioOro = null ;
                this.punteggioArgento = null ;
                this.punteggioBronzo = null ;
                this.dataInizio = null;
                this.dataFine = null;
                this.generaNodo = false ;
                this.nodeTitle = "" ;
                this.templateIdentifier = "" ;
                this.nodePath = [];
        }
}

export class ChatMessage {
    senderIdentifier : string;
    senderName : string;
    identifier : string;
    timestamp : number;
    text : string;
    quotedMessage : QuotedMessage;

    constructor() 
    {
    	            this.senderIdentifier = "" ;
                this.senderName = "" ;
                this.identifier = "" ;
                this.timestamp = null ;
                this.text = "" ;
                this.quotedMessage = new QuotedMessage();
        }
}

export class QuotedMessage {
    sender : string;
    text : string;

    constructor() 
    {
    	            this.sender = "" ;
                this.text = "" ;
        }
}

export class ChatRoomVm {
    userIdentifier : string;
    userName : string;
    chatIdentifier : string;
    lastMessageTimeStamp : number;

    constructor() 
    {
    	            this.userIdentifier = "" ;
                this.userName = "" ;
                this.chatIdentifier = "" ;
                this.lastMessageTimeStamp = null ;
        }
}

export class SendMessageVm {
    chatRoomIdentifier : string;
    text : string;
    senderIdentifier : string;
    senderName : string;
    quotedMessage : QuotedMessage;

    constructor() 
    {
    	            this.chatRoomIdentifier = "" ;
                this.text = "" ;
                this.senderIdentifier = "" ;
                this.senderName = "" ;
                this.quotedMessage = new QuotedMessage();
        }
}

export class Cintura extends BaseEntity {
    idExcel : number;
    ordinamento : number;
    nome : string;
    hexColor : string;
    percentualePerCompletamento : number;

    constructor() 
    {
    	        super();
		            this.idExcel = null ;
                this.ordinamento = null ;
                this.nome = "" ;
                this.hexColor = "" ;
                this.percentualePerCompletamento = null ;
        }
}

export class CinturaWithTemiVm {
    enabled : boolean;
    nome : string;
    hexColor : string;
    identifier : string;
    temi : TemaVm[];
    progress : number;

    constructor() 
    {
    	            this.enabled = false ;
                this.nome = "" ;
                this.hexColor = "" ;
                this.identifier = "" ;
                this.temi = [];
                this.progress = null ;
        }
}

export class TemaVm {
    nome : string;
    identifier : string;
    completamento : number;
    icona : string;

    constructor() 
    {
    	            this.nome = "" ;
                this.identifier = "" ;
                this.completamento = null ;
                this.icona = "" ;
        }
}

export class DomandaQualitaConfig extends BaseEntity {
    testoDomanda : string;
    tipoRisposta : string;
    scelte : string[];

    constructor() 
    {
    	        super();
		            this.testoDomanda = "" ;
                this.tipoRisposta = "" ;
                this.scelte = [];
        }
}

export class ProviderTokenLoginVm {
    access_token : string;
    password : string;
    appVersion : string;

    constructor() 
    {
    	            this.access_token = "" ;
                this.password = "" ;
                this.appVersion = "" ;
        }
}

export class FriendChallengeInvite extends BaseEntity {
    challengeIdentifier : string;
    friendChallengeIdentifier : string;
    friendChallengeName : string;
    senderIdentifier : string;
    senderName : string;
    invitedUserIdentifier : string;
    invitedUserName : string;
    azzeraDati : boolean;
    status : string;

    constructor() 
    {
    	        super();
		            this.challengeIdentifier = "" ;
                this.friendChallengeIdentifier = "" ;
                this.friendChallengeName = "" ;
                this.senderIdentifier = "" ;
                this.senderName = "" ;
                this.invitedUserIdentifier = "" ;
                this.invitedUserName = "" ;
                this.azzeraDati = false ;
                this.status = "" ;
        }
}

export class FriendChallengeListVm {
    name : string;
    challengeIdentifier : string;
    challengeName : string;

    constructor() 
    {
    	            this.name = "" ;
                this.challengeIdentifier = "" ;
                this.challengeName = "" ;
        }
}

export class CreateFriendChallengeVm {
    name : string;
    challengeIdentifier : string;
    challengeName : string;
    invitedUsers : ValueIdentifierOfString[];
    azzeraDati : boolean;

    constructor() 
    {
    	            this.name = "" ;
                this.challengeIdentifier = "" ;
                this.challengeName = "" ;
                this.invitedUsers = [];
                this.azzeraDati = false ;
        }
}

export class FriendChallenge extends BaseEntity {
    name : string;
    dataInizio : string ;
    challengeIdentifier : string;
    creatorIdentifier : string;
    creatorName : string;
    challengeName : string;
    users : FriendChallengeUser[];

    constructor() 
    {
    	        super();
		            this.name = "" ;
                this.dataInizio = null;
                this.challengeIdentifier = "" ;
                this.creatorIdentifier = "" ;
                this.creatorName = "" ;
                this.challengeName = "" ;
                this.users = [];
        }
}

export class FriendChallengeUser {
    userIdentifier : string;
    userName : string;
    dataIngresso : string ;
    variazioneIniziale : number;

    constructor() 
    {
    	            this.userIdentifier = "" ;
                this.userName = "" ;
                this.dataIngresso = null;
                this.variazioneIniziale = null ;
        }
}

export class RankingCardVm {
    userIdentifier : string;
    isSelf : boolean;
    playerName : string;
    totalPoints : number;
    performance : number;
    flag : string;
    cintura : string;
    coloreCintura : string;
    imageUrl : string;
    vsPrevious : number;
    punteggioLearning : number;
    punteggioGaming : number;
    premiUser : PremioUserVm[];

    constructor() 
    {
    	            this.userIdentifier = "" ;
                this.isSelf = false ;
                this.playerName = "" ;
                this.totalPoints = null ;
                this.performance = null ;
                this.flag = "" ;
                this.cintura = "" ;
                this.coloreCintura = "" ;
                this.imageUrl = "" ;
                this.vsPrevious = null ;
                this.punteggioLearning = null ;
                this.punteggioGaming = null ;
                this.premiUser = [];
        }
}

export class PremioUserVm {
    tipoPremio : string;
    podioUno : number;
    podioDue : number;
    podioTre : number;

    constructor() 
    {
    	            this.tipoPremio = "" ;
                this.podioUno = null ;
                this.podioDue = null ;
                this.podioTre = null ;
        }
}

export class FriendChallengeVm {
    identifier : string;
    name : string;
    dataInizio : string ;
    userCount : number;
    creatorIdentifier : string;
    creatorName : string;

    constructor() 
    {
    	            this.identifier = "" ;
                this.name = "" ;
                this.dataInizio = null;
                this.userCount = null ;
                this.creatorIdentifier = "" ;
                this.creatorName = "" ;
        }
}

export class GlobalConfig extends BaseEntity {
    systemDate : string ;
    dizionario : TimedDictionaryOfStringAndString;
    dizionarioHtml : TimedDictionaryOfStringAndString;
    firstChatMessage : string;
    minimumAppVersion : string;
    comuni : Comune[];
    questionarioInizialeConfig : QuestionarioInizialeConfig;

    constructor() 
    {
    	        super();
		            this.systemDate = null;
                this.dizionario = new TimedDictionaryOfStringAndString();
                this.dizionarioHtml = new TimedDictionaryOfStringAndString();
                this.firstChatMessage = "" ;
                this.minimumAppVersion = "" ;
                this.comuni = [];
                this.questionarioInizialeConfig = new QuestionarioInizialeConfig();
        }
}

export class TimedDictionaryOfStringAndString {
    timestamp : number;
    dictValues : { [key: string]: string; };

    constructor() 
    {
    	            this.timestamp = null ;
                this.dictValues = null;
        }
}

export class Comune {
    nome : string;
    provincia : string;
    provinciaSigla : string;
    regione : string;

    constructor() 
    {
    	            this.nome = "" ;
                this.provincia = "" ;
                this.provinciaSigla = "" ;
                this.regione = "" ;
        }
}

export class QuestionarioInizialeConfig {
    fasceDiEtaOptions : QuestionarioInizialeOption[];
    statoLavorativoOptions : QuestionarioInizialeOption[];
    conoscenzaFinanziariaOptions : QuestionarioInizialeOption[];
    comeMaiInteresseOptions : QuestionarioInizialeOption[];
    comeSeiArrivatoOptions : QuestionarioInizialeOption[];
    quantoTempoPensiOptions : QuestionarioInizialeOption[];

    constructor() 
    {
    	            this.fasceDiEtaOptions = [];
                this.statoLavorativoOptions = [];
                this.conoscenzaFinanziariaOptions = [];
                this.comeMaiInteresseOptions = [];
                this.comeSeiArrivatoOptions = [];
                this.quantoTempoPensiOptions = [];
        }
}

export class QuestionarioInizialeOption {
    value : number;
    text : string;
    enabled : boolean;
    ordinamento : number;

    constructor() 
    {
    	            this.value = null ;
                this.text = "" ;
                this.enabled = false ;
                this.ordinamento = null ;
        }
}

export class GlossarioGroupVm {
    group : string;
    elements : GlossarioVm[];

    constructor() 
    {
    	            this.group = "" ;
                this.elements = [];
        }
}

export class GlossarioVm {
    identifier : string;
    key : string;

    constructor() 
    {
    	            this.identifier = "" ;
                this.key = "" ;
        }
}

export class Glossario extends BaseEntity {
    key : string;
    content : LezioneContent;
    group : string;

    constructor() 
    {
    	        super();
		            this.key = "" ;
                this.content = new LezioneContent();
                this.group = "" ;
        }
}

export class LezioneContent {
    html1 : string;
    imageUrl1 : string;
    html2 : string;
    imageUrl2 : string;
    html3 : string;

    constructor() 
    {
    	            this.html1 = "" ;
                this.imageUrl1 = "" ;
                this.html2 = "" ;
                this.imageUrl2 = "" ;
                this.html3 = "" ;
        }
}

export class ImageForLessonGroupVm {
    group : string;
    elements : ImageForLessonVm[];

    constructor() 
    {
    	            this.group = "" ;
                this.elements = [];
        }
}

export class ImageForLessonVm {
    fileName : string;
    url : string;

    constructor() 
    {
    	            this.fileName = "" ;
                this.url = "" ;
        }
}

export class Lezione extends BaseEntity {
    titolo : string;
    idExcel : number;
    nomeTema : string;
    percorsoName : string;
    temaIdentifier : string;
    nomeCintura : string;
    cinturaIdentifier : string;
    ordinamentoCintura : number;
    content : LezioneContent;
    questionario : Questionario;
    punteggioLezione : number;
    ordinamento : number;
    revisione : string;
    pollyUrl : string;
    usePolly : boolean;

    constructor() 
    {
    	        super();
		            this.titolo = "" ;
                this.idExcel = null ;
                this.nomeTema = "" ;
                this.percorsoName = "" ;
                this.temaIdentifier = "" ;
                this.nomeCintura = "" ;
                this.cinturaIdentifier = "" ;
                this.ordinamentoCintura = null ;
                this.content = new LezioneContent();
                this.questionario = new Questionario();
                this.punteggioLezione = null ;
                this.ordinamento = null ;
                this.revisione = "" ;
                this.pollyUrl = "" ;
                this.usePolly = false ;
        }
}

export class Questionario {
    domande : Domanda[];
    punteggioMinimo : number;

    constructor() 
    {
    	            this.domande = [];
                this.punteggioMinimo = null ;
        }
}

export class Domanda {
    testo : string;
    ordinamento : number;
    risposte : Risposta[];

    constructor() 
    {
    	            this.testo = "" ;
                this.ordinamento = null ;
                this.risposte = [];
        }
}

export class Risposta {
    testo : string;
    valore : number;
    testoRiepilogo : string;

    constructor() 
    {
    	            this.testo = "" ;
                this.valore = null ;
                this.testoRiepilogo = "" ;
        }
}

export class LezioneGroupedVm {
    cintura : string;
    hexColor : string;
    cinturaIdentifier : string;
    cinturaProgress : number;
    elements : LezioneVm[];
    enabled : boolean;

    constructor() 
    {
    	            this.cintura = "" ;
                this.hexColor = "" ;
                this.cinturaIdentifier = "" ;
                this.cinturaProgress = null ;
                this.elements = [];
                this.enabled = false ;
        }
}

export class LezioneVm {
    identifier : string;
    titolo : string;
    cinturaIdentifier : string;

    constructor() 
    {
    	            this.identifier = "" ;
                this.titolo = "" ;
                this.cinturaIdentifier = "" ;
        }
}

export class GeneratePollyVm {
    lezioneIdentifier : string;
    cintura : string;
    tema : string;
    lezione : string;

    constructor() 
    {
    	            this.lezioneIdentifier = "" ;
                this.cintura = "" ;
                this.tema = "" ;
                this.lezione = "" ;
        }
}

export class Movimento extends BaseEntity {
    userIdentifier : string;
    portafoglioIdentifier : string;
    tipoMovimento : TipoOrdine;
    dataMovimento : string ;
    dataEsecuzione : string ;
    codiceStrumento : string;
    idExcelStrumento : number;
    strumentoIdentifier : string;
    quantita : number;
    controvalore : number;
    controvaloreValuta : number;
    prezzo : number;
    prezzoValuta : number;
    valuta : string;
    commissioni : number;

    constructor() 
    {
    	        super();
		            this.userIdentifier = "" ;
                this.portafoglioIdentifier = "" ;
                this.tipoMovimento = null;
                this.dataMovimento = null;
                this.dataEsecuzione = null;
                this.codiceStrumento = "" ;
                this.idExcelStrumento = null ;
                this.strumentoIdentifier = "" ;
                this.quantita = null ;
                this.controvalore = null ;
                this.controvaloreValuta = null ;
                this.prezzo = null ;
                this.prezzoValuta = null ;
                this.valuta = "" ;
                this.commissioni = null ;
        }
}

export enum TipoOrdine {
    Acquisto = 1,
    Vendita = 2,
    VenditaSwitch = 3,
    AcquistoSwitch = 4,
}

export class Ordine extends BaseEntity {
    userIdentifier : string;
    userBalanceIdentifier : string;
    movimentoIdentifier : string;
    tipoOrdine : TipoOrdine;
    dataOrdine : string ;
    dataMovimento : string ;
    nomeAsset : string;
    assetType : string;
    tipoAsset : string;
    codiceAsset : string;
    idExcelStrumento : number;
    assetIdentifier : string;
    offsetStrumento : number;
    prezzo : number;
    prezzoValuta : number;
    quantita : number;
    controvalore : number;
    controvaloreValuta : number;
    dataValuta : string ;
    valuta : string;
    percentualeCommissioni : number;
    switchIdentifier : string;
    quantitaPercentuale : number;

    constructor() 
    {
    	        super();
		            this.userIdentifier = "" ;
                this.userBalanceIdentifier = "" ;
                this.movimentoIdentifier = "" ;
                this.tipoOrdine = null;
                this.dataOrdine = null;
                this.dataMovimento = null;
                this.nomeAsset = "" ;
                this.assetType = "" ;
                this.tipoAsset = "" ;
                this.codiceAsset = "" ;
                this.idExcelStrumento = null ;
                this.assetIdentifier = "" ;
                this.offsetStrumento = null ;
                this.prezzo = null ;
                this.prezzoValuta = null ;
                this.quantita = null ;
                this.controvalore = null ;
                this.controvaloreValuta = null ;
                this.dataValuta = null;
                this.valuta = "" ;
                this.percentualeCommissioni = null ;
                this.switchIdentifier = "" ;
                this.quantitaPercentuale = null ;
        }
}

export class CreaOrdineVm {
    userIdentifier : string;
    portafoglioIdentifier : string;
    tipoOrdine : TipoOrdine;
    assetIdentifier : string;
    assetName : string;
    assetType : string;
    controvalore : number;
    dataOrdine : string ;

    constructor() 
    {
    	            this.userIdentifier = "" ;
                this.portafoglioIdentifier = "" ;
                this.tipoOrdine = null;
                this.assetIdentifier = "" ;
                this.assetName = "" ;
                this.assetType = "" ;
                this.controvalore = null ;
                this.dataOrdine = null;
        }
}

export class CreaSwitchVm {
    userIdentifier : string;
    walletIdentifier : string;
    ordiniVendita : CreaOrdineVm[];
    ordiniAcquisto : CreaOrdineVm[];

    constructor() 
    {
    	            this.userIdentifier = "" ;
                this.walletIdentifier = "" ;
                this.ordiniVendita = [];
                this.ordiniAcquisto = [];
        }
}

export class GetOrdiniPendingResponseVm {
    switches : SwitchPendingVm[];
    ordini : OrdinePendingVm[];

    constructor() 
    {
    	            this.switches = [];
                this.ordini = [];
        }
}

export class SwitchPendingVm {
    deletable : boolean;
    orders : OrdinePendingVm[];

    constructor() 
    {
    	            this.deletable = false ;
                this.orders = [];
        }
}

export class OrdinePendingVm {
    identifier : string;
    tipoOrdine : TipoOrdine;
    strumento : string;
    tipoAsset : string;
    controvalore : number;
    peso : number;
    dataOrdine : string ;
    dataMovimento : string ;
    deletable : boolean;

    constructor() 
    {
    	            this.identifier = "" ;
                this.tipoOrdine = null;
                this.strumento = "" ;
                this.tipoAsset = "" ;
                this.controvalore = null ;
                this.peso = null ;
                this.dataOrdine = null;
                this.dataMovimento = null;
                this.deletable = false ;
        }
}

export class DeleteMultipleVm {
    orders : OrdinePendingVm[];

    constructor() 
    {
    	            this.orders = [];
        }
}

export class CreateUserBalanceVm {
    userIdentifier : string;
    challengeIdentifier : string;
    nomeGara : string;
    balance : number;
    forceBalance : boolean;
    fromDate : string ;

    constructor() 
    {
    	            this.userIdentifier = "" ;
                this.challengeIdentifier = "" ;
                this.nomeGara = "" ;
                this.balance = null ;
                this.forceBalance = false ;
                this.fromDate = null;
        }
}

export class ValueIdentifierOfGuid {
    identifier : string;
    value : string;

    constructor() 
    {
    	            this.identifier = "" ;
                this.value = "" ;
        }
}

export class Portafoglio extends BaseEntity {
    userIdentifier : string;
    startingBalance : number;
    startingDate : string ;
    challengeIdentifier : string;
    nomeGara : string;
    challengeRisk : number;
    resoconto : ResocontoPortafoglio;

    constructor() 
    {
    	        super();
		            this.userIdentifier = "" ;
                this.startingBalance = null ;
                this.startingDate = null;
                this.challengeIdentifier = "" ;
                this.nomeGara = "" ;
                this.challengeRisk = null ;
                this.resoconto = new ResocontoPortafoglio();
        }
}

export class ResocontoPortafoglio {
    performance : DateValue[];
    controValore : DateValue[];
    variazioneGiornaliera : DateValue[];
    volatilita20 : DateValue[];
    utiliPerdite : DateValue[];
    peso : DateValue[];
    commissioni : DateValue[];
    commissioniPerc : DateValue[];
    retrocessioni : DateValue[];
    retrocessioniPerc : DateValue[];

    constructor() 
    {
    	            this.performance = [];
                this.controValore = [];
                this.variazioneGiornaliera = [];
                this.volatilita20 = [];
                this.utiliPerdite = [];
                this.peso = [];
                this.commissioni = [];
                this.commissioniPerc = [];
                this.retrocessioni = [];
                this.retrocessioniPerc = [];
        }
}

export class DataForCalcoloAcquistoVm {
    tipoAsset : string;
    lastNav : number;
    variazioniAsset : number[];
    variazioniPesate : number[];

    constructor() 
    {
    	            this.tipoAsset = "" ;
                this.lastNav = null ;
                this.variazioniAsset = [];
                this.variazioniPesate = [];
        }
}

export class GetDataForCalcoloAcquistoVm {
    portafoglioIdentifier : string;
    assetIdentifier : string;
    creaSwitchVm : CreaSwitchVm;

    constructor() 
    {
    	            this.portafoglioIdentifier = "" ;
                this.assetIdentifier = "" ;
                this.creaSwitchVm = new CreaSwitchVm();
        }
}

export class PortafoglioStatusVm {
    portafoglioIdentifier : string;
    controvalorePortafoglio : number;
    liquidity : number;
    liquidityPercentage : number;
    walletRisk : number;
    matchRisk : number;
    percentuali : TypeForDonutChartVm[];
    analysisEnabled : boolean;

    constructor() 
    {
    	            this.portafoglioIdentifier = "" ;
                this.controvalorePortafoglio = null ;
                this.liquidity = null ;
                this.liquidityPercentage = null ;
                this.walletRisk = null ;
                this.matchRisk = null ;
                this.percentuali = [];
                this.analysisEnabled = false ;
        }
}

export class TypeForDonutChartVm {
    nome : string;
    peso : number;

    constructor() 
    {
    	            this.nome = "" ;
                this.peso = null ;
        }
}

export class GetPortafoglioStatusWithSwitchVm {
    portafoglioIdentifier : string;
    creaSwitchVm : CreaSwitchVm;

    constructor() 
    {
    	            this.portafoglioIdentifier = "" ;
                this.creaSwitchVm = new CreaSwitchVm();
        }
}

export class KeyValuePairOfStringAndResocontoPortafoglio {
    key : string;
    value : ResocontoPortafoglio;

    constructor() 
    {
    	            this.key = "" ;
                this.value = new ResocontoPortafoglio();
        }
}

export class AssetForDonutChart {
    assetIdentifier : string;
    tipo : string;
    nome : string;
    valuta : string;
    quantita : number;
    peso : number;
    controvalore : number;
    performanceYtd : number;
    performance1Year : number;
    performance3Year : number;
    volatilita750 : number;

    constructor() 
    {
    	            this.assetIdentifier = "" ;
                this.tipo = "" ;
                this.nome = "" ;
                this.valuta = "" ;
                this.quantita = null ;
                this.peso = null ;
                this.controvalore = null ;
                this.performanceYtd = null ;
                this.performance1Year = null ;
                this.performance3Year = null ;
                this.volatilita750 = null ;
        }
}

export class ProgressiUser extends BaseEntity {
    userIdentifier : string;
    progressiCinture : ProgressoCinturaVm[];
    progressiTema : ProgressoTema[];
    lezioniSuperate : LezioneSuperata[];

    constructor() 
    {
    	        super();
		            this.userIdentifier = "" ;
                this.progressiCinture = [];
                this.progressiTema = [];
                this.lezioniSuperate = [];
        }
}

export class ProgressoCinturaVm {
    identifier : string;
    nome : string;
    hexColor : string;
    progress : number;

    constructor() 
    {
    	            this.identifier = "" ;
                this.nome = "" ;
                this.hexColor = "" ;
                this.progress = null ;
        }
}

export class ProgressoTema {
    percorsoNome : string;
    temaIdentifier : string;
    cinturaIdentifier : string;
    percentuale : number;

    constructor() 
    {
    	            this.percorsoNome = "" ;
                this.temaIdentifier = "" ;
                this.cinturaIdentifier = "" ;
                this.percentuale = null ;
        }
}

export class LezioneSuperata {
    identifier : string;
    idExcel : number;
    value : number;
    date : string ;

    constructor() 
    {
    	            this.identifier = "" ;
                this.idExcel = null ;
                this.value = null ;
                this.date = null;
        }
}

export class SendPushConfigVm {
    title : string;
    message : string;
    routeTo : string;
    userIds : string[];

    constructor() 
    {
    	            this.title = "" ;
                this.message = "" ;
                this.routeTo = "" ;
                this.userIds = [];
        }
}

export class RankingFilterVm {
    challengeIdentifier : string;
    periodo : string;
    fasciaDiEta : number;
    statoLavorativo : number;
    conoscenzaFinanziaria : number;
    areaGeo1 : string;
    areaGeo2 : string;
    areaGeo3 : string;

    constructor() 
    {
    	            this.challengeIdentifier = "" ;
                this.periodo = "" ;
                this.fasciaDiEta = null ;
                this.statoLavorativo = null ;
                this.conoscenzaFinanziaria = null ;
                this.areaGeo1 = "" ;
                this.areaGeo2 = "" ;
                this.areaGeo3 = "" ;
        }
}

export class RispostaQualita extends BaseEntity {
    userIdentifier : string;
    userName : string;
    lezioneIdentifier : string;
    lezioneIdExcel : number;
    titoloLezione : string;
    nomeCintura : string;
    nomeTema : string;
    revisioneLezione : string;
    risposte : DomandaWithRisposta[];
    commento : string;

    constructor() 
    {
    	        super();
		            this.userIdentifier = "" ;
                this.userName = "" ;
                this.lezioneIdentifier = "" ;
                this.lezioneIdExcel = null ;
                this.titoloLezione = "" ;
                this.nomeCintura = "" ;
                this.nomeTema = "" ;
                this.revisioneLezione = "" ;
                this.risposte = [];
                this.commento = "" ;
        }
}

export class DomandaWithRisposta {
    domanda : string;
    risposta : string;

    constructor() 
    {
    	            this.domanda = "" ;
                this.risposta = "" ;
        }
}

export class RispostaQualitaVm {
    identifier : string;
    userIdentifier : string;
    userName : string;
    lezioneIdentifier : string;
    titoloLezione : string;
    nomeCintura : string;
    nomeTema : string;
    risposte : DomandaWithRisposta[];
    commento : string;

    constructor() 
    {
    	            this.identifier = "" ;
                this.userIdentifier = "" ;
                this.userName = "" ;
                this.lezioneIdentifier = "" ;
                this.titoloLezione = "" ;
                this.nomeCintura = "" ;
                this.nomeTema = "" ;
                this.risposte = [];
                this.commento = "" ;
        }
}

export class SaveQuestionarioResponseVm {
    lezioneSuperata : boolean;
    cintura : string;
    tema : string;
    cinturaProgressFrom : number;
    cinturaProgressTo : number;
    temaProgressFrom : number;
    temaProgressTo : number;
    newCintura : boolean;
    nextCintura : string;
    nextCinturaColor : string;
    risposte : RispostaAlQuestionario[];

    constructor() 
    {
    	            this.lezioneSuperata = false ;
                this.cintura = "" ;
                this.tema = "" ;
                this.cinturaProgressFrom = null ;
                this.cinturaProgressTo = null ;
                this.temaProgressFrom = null ;
                this.temaProgressTo = null ;
                this.newCintura = false ;
                this.nextCintura = "" ;
                this.nextCinturaColor = "" ;
                this.risposte = [];
        }
}

export class RispostaAlQuestionario {
    testoDomanda : string;
    testoRisposta : string;
    valore : number;
    testoRiepilogo : string;

    constructor() 
    {
    	            this.testoDomanda = "" ;
                this.testoRisposta = "" ;
                this.valore = null ;
                this.testoRiepilogo = "" ;
        }
}

export class RisultatoQuestionarioVm {
    userIdentifier : string;
    lezioneIdentifier : string;
    cinturaIdentifier : string;
    temaIdentifier : string;
    risposte : RispostaAlQuestionario[];

    constructor() 
    {
    	            this.userIdentifier = "" ;
                this.lezioneIdentifier = "" ;
                this.cinturaIdentifier = "" ;
                this.temaIdentifier = "" ;
                this.risposte = [];
        }
}

export class RisultatoQuestionario extends BaseEntity {
    userIdentifier : string;
    userName : string;
    lezioneIdExcel : number;
    lezioneIdentifier : string;
    lezioneName : string;
    cinturaIdentifier : string;
    cinturaName : string;
    temaIdentifier : string;
    temaName : string;
    risposte : RispostaAlQuestionario[];
    isSuperato : boolean;

    constructor() 
    {
    	        super();
		            this.userIdentifier = "" ;
                this.userName = "" ;
                this.lezioneIdExcel = null ;
                this.lezioneIdentifier = "" ;
                this.lezioneName = "" ;
                this.cinturaIdentifier = "" ;
                this.cinturaName = "" ;
                this.temaIdentifier = "" ;
                this.temaName = "" ;
                this.risposte = [];
                this.isSuperato = false ;
        }
}

export class Tema extends BaseEntity {
    idExcel : number;
    ordinamento : number;
    nome : string;
    icona : string;
    cintureCollegate : string[];

    constructor() 
    {
    	        super();
		            this.idExcel = null ;
                this.ordinamento = null ;
                this.nome = "" ;
                this.icona = "" ;
                this.cintureCollegate = [];
        }
}

export class TemaWithLezioni {
    identifier : string;
    titolo : string;
    lezioni : LezioneVm[];

    constructor() 
    {
    	            this.identifier = "" ;
                this.titolo = "" ;
                this.lezioni = [];
        }
}

export class Template extends BaseEntity {
    nome : string;
    htmlText : string;
    logicBlockDefinitions : LogicBlockDefinition[];

    constructor() 
    {
    	        super();
		            this.nome = "" ;
                this.htmlText = "" ;
                this.logicBlockDefinitions = [];
        }
}

export class LogicBlockDefinition {
    propertyA : string;
    propertyB : string;
    valueA : IComparable;
    valueB : IComparable;
    compareOperator : CompareOperator;

    constructor() 
    {
    	            this.propertyA = "" ;
                this.propertyB = "" ;
                this.valueA = new IComparable();
                this.valueB = new IComparable();
                this.compareOperator = null;
        }
}

export class IComparable {

    constructor() 
    {
    	    }
}

export enum CompareOperator {
    Equals = 0,
    Different = 1,
    MoreThan = 2,
    LessThan = 3,
    MoreThanOrEqual = 4,
    LessThanOrEqual = 5,
}

export class BaseCredential {
    email : string;
    password : string;

    constructor() 
    {
    	            this.email = "" ;
                this.password = "" ;
        }
}

export class UserVm {
    identifier : string;
    name : string;
    surname : string;
    alias : string;
    phoneNumber : string;
    imageUrl : string;
    email : string;
    lastLoginOn : string ;
    lastLoginVersion : string;

    constructor() 
    {
    	            this.identifier = "" ;
                this.name = "" ;
                this.surname = "" ;
                this.alias = "" ;
                this.phoneNumber = "" ;
                this.imageUrl = "" ;
                this.email = "" ;
                this.lastLoginOn = null;
                this.lastLoginVersion = "" ;
        }
}

export class User extends BaseEntity {
    name : string;
    surname : string;
    alias : string;
    phoneNumber : string;
    imageUrl : string;
    isMale : boolean;
    loginData : LoginData2;
    info : Info;
    puntiTotali : number;
    emailConfirmed : boolean;
    playDisclaimerAccepted : boolean;
    avvisatoQuestionario : boolean;
    lastLoginVersion : string;
    lastLoginOn : string ;
    fcmId : string;
    completeName : string;
    socialLoginData : ISocialLoginData;

    constructor() 
    {
    	        super();
		            this.name = "" ;
                this.surname = "" ;
                this.alias = "" ;
                this.phoneNumber = "" ;
                this.imageUrl = "" ;
                this.isMale = false ;
                this.loginData = new LoginData2();
                this.info = new Info();
                this.puntiTotali = null ;
                this.emailConfirmed = false ;
                this.playDisclaimerAccepted = false ;
                this.avvisatoQuestionario = false ;
                this.lastLoginVersion = "" ;
                this.lastLoginOn = null;
                this.fcmId = "" ;
                this.completeName = "" ;
                this.socialLoginData = new ISocialLoginData();
        }
}

export class LoginData2 extends BaseCredential {
    role : string;
    resetPassword : string;
    externalProviders : KeyValuePairOfStringAndString[];

    constructor() 
    {
    	        super();
		            this.role = "" ;
                this.resetPassword = "" ;
                this.externalProviders = [];
        }
}

export class KeyValuePairOfStringAndString {
    key : string;
    value : string;

    constructor() 
    {
    	            this.key = "" ;
                this.value = "" ;
        }
}

export class Info {
    sesso : string;
    fasciaDiEta : number;
    statoLavorativo : number;
    conoscenzaFinanziaria : number;
    areaGeo1 : string;
    areaGeo2 : string;
    areaGeo3 : string;
    comeMaiInteresse : number;
    comeSeiArrivato : number;
    quantoTempoPensi : number;

    constructor() 
    {
    	            this.sesso = "" ;
                this.fasciaDiEta = null ;
                this.statoLavorativo = null ;
                this.conoscenzaFinanziaria = null ;
                this.areaGeo1 = "" ;
                this.areaGeo2 = "" ;
                this.areaGeo3 = "" ;
                this.comeMaiInteresse = null ;
                this.comeSeiArrivato = null ;
                this.quantoTempoPensi = null ;
        }
}

export class ISocialLoginData {
    externalProviders : KeyValuePairOfStringAndString[];

    constructor() 
    {
    	            this.externalProviders = [];
        }
}

export class ProfileVm {
    identifier : string;
    name : string;
    surname : string;
    alias : string;
    punteggioLearning : number;
    punteggioGaming : number;
    info : Info;
    premiUser : PremioUserVm[];

    constructor() 
    {
    	            this.identifier = "" ;
                this.name = "" ;
                this.surname = "" ;
                this.alias = "" ;
                this.punteggioLearning = null ;
                this.punteggioGaming = null ;
                this.info = new Info();
                this.premiUser = [];
        }
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}